import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS2() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/clrhs2.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS2
